import { useDarkModeTheme } from '@therms/atalaya';
import React, { useState } from 'react';
import DarkModeToggle from 'react-dark-mode-toggle';

export const ToggleDarkMode = () => {
  const [isDark, setDarkMode] = useDarkModeTheme();

  return <DarkModeToggle onChange={setDarkMode} checked={isDark} size={50} />;
};
